/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
class Shaky {
  constructor(canvas) {
    this.canvas = null;
    this.context = null;
    this.segSize = 6;
    this.shake = 3;
    this.x = 0;
    this.y = 0;
    this.prevX = 0;
    this.prevY = 0;
    this.width = 0;
    this.height = 0;

    let tempCanvas = canvas;
    if (typeof canvas === 'string') {
      tempCanvas = document.getElementById(canvas);
    }
    this.canvas = tempCanvas;
    this.context = this.canvas.getContext('2d');
    this.width = this.canvas.width;
    this.height = this.canvas.height;
  }

  setSize(width, height) {
    this.canvas.width = width;
    this.width = width;
    this.canvas.height = height;
    this.height = height;
  }

  clear() {
    this.context.clearRect(0, 0, this.width, this.height);
  }

  beginPath() {
    this.context.beginPath();
  }

  stroke() {
    this.context.stroke();
  }

  fill() {
    this.context.fill();
  }

  rect(x, y, w, h) {
    this.moveTo(x, y);
    const startX = this.x;
    const startY = this.y;
    this.lineTo(x + w, y);
    this.lineTo(x + w, y + h);
    this.lineTo(x, y + h);
    this.lineTo(startX, startY, true);
  }

  fillRect(x, y, w, h) {
    this.beginPath();
    this.rect(x, y, w, h);
    this.fill();
  }

  clearRect(x, y, w, h) {
    this.context.clearRect(x, y, w, h);
  }

  strokeRect(x, y, w, h) {
    this.beginPath();
    this.rect(x, y, w, h);
    this.stroke();
  }

  moveTo(x, y) {
    this.setXY(
      x + Math.random() * this.shake - this.shake / 2,
      y + Math.random() * this.shake - this.shake / 2,
    );
    this.context.moveTo(this.x, this.y);
  }

  lineTo(x, y, exactEnd) {
    const toX = exactEnd ? x : x + Math.random() * this.shake - this.shake / 2;
    const toY = exactEnd ? y : y + Math.random() * this.shake - this.shake / 2;
    const dx = toX - this.x;
    const dy = toY - this.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const steps = Math.floor(dist / this.segSize);
    const resX = dx / steps;
    const resY = dy / steps;

    for (let i = 1; i < steps; i += 1) {
      this.context.lineTo(
        this.x + resX * i + Math.random() * this.shake - this.shake / 2,
        this.y + resY * i + Math.random() * this.shake - this.shake / 2,
      );
    }
    this.context.lineTo(toX, toY);
    this.setXY(toX, toY);
  }

  arc(x, y, r, start, end) {
    while (end < start) end += Math.PI * 2;

    this.moveTo(
      x + Math.cos(start) * r,
      y + Math.sin(start) * r,
    );
    const slice = (Math.PI * 2) / Math.floor((r * Math.PI * 2) / this.segSize);

    for (let angle = start + slice; angle < end; angle += slice) {
      this.context.lineTo(
        x + Math.cos(angle) * r + Math.random() * this.shake - this.shake / 2,
        y + Math.sin(angle) * r + Math.random() * this.shake - this.shake / 2,
      );
    }
    this.setXY(
      x + Math.cos(end) * r + Math.random() * this.shake - this.shake / 2,
      y + Math.sin(end) * r + Math.random() * this.shake - this.shake / 2,
    );
    this.context.lineTo(this.x, this.y);
  }

  circle(x, y, r) {
    const slice = (Math.PI * 2) / Math.floor((r * (Math.PI * 2)) / this.segSize);
    this.arc(x, y, r, 0, Math.PI * 2 - slice);
    this.setXY(this.prevX, this.prevY);
    this.context.lineTo(this.x, this.y);
  }

  fillCircle(x, y, r) {
    this.beginPath();
    this.circle(x, y, r);
    this.fill();
  }

  strokeCircle(x, y, r) {
    this.beginPath();
    this.circle(x, y, r);
    this.stroke();
  }

  ellipse(x, y, xr, yr) {
    this.moveTo(x + xr, y);
    const slice = (Math.PI * 2) / Math.floor(((xr + yr) / 2) * ((Math.PI * 2) / this.segSize));

    for (let angle = slice; angle < Math.PI * 2 - slice; angle += slice) {
      this.context.lineTo(
        x + Math.cos(angle) * xr + Math.random() * this.shake - this.shake / 2,
        y + Math.sin(angle) * yr + Math.random() * this.shake - this.shake / 2,
      );
    }
    this.context.lineTo(this.x, this.y);
  }

  fillEllipse(x, y, xr, yr) {
    this.beginPath();
    this.ellipse(x, y, xr, yr);
    this.fill();
  }

  strokeEllipse(x, y, xr, yr) {
    this.beginPath();
    this.ellipse(x, y, xr, yr);
    this.stroke();
  }

  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    const x0 = this.x;
    const y0 = this.y;
    const distance = this.distance(x0, y0, x1, y1) + this.distance(x1, y1, x2, y2) + this.distance(x2, y2, x3, y3);
    const res = this.segSize / distance;

    for (let t = 0; t < 1; t += res) {
      this.context.lineTo(
        (1 - t ** 3) * x0 + 3 * (1 - t ** 2) * t * x1 + 3 * (1 - t) * t * t * x2 + t * t * t * x3 + Math.random() * this.shake - this.shake / 2,
        (1 - t ** 3) * y0 + 3 * (1 - t ** 2) * t * y1 + 3 * (1 - t) * t * t * y2 + t * t * t * y3 + Math.random() * this.shake - this.shake / 2,
      );
    }
    this.setXY(
      x3 + Math.random() * this.shake - this.shake / 2,
      y3 + Math.random() * this.shake - this.shake / 2,
    );
    this.context.lineTo(this.x, this.y);
  }

  quadraticCurveTo(x1, y1, x2, y2) {
    const x0 = this.x;
    const y0 = this.y;
    const distance = this.distance(x0, y0, x1, y1) + this.distance(x1, y1, x2, y2);
    const res = this.segSize / distance;

    for (let t = 0; t < 1; t += res) {
      this.context.lineTo(
        (1 - t ** 2) * x0 + 2 * (1 - t) * t * x1 + t * t * x2 + Math.random() * this.shake - this.shake / 2,
        (1 - t ** 2) * y0 + 2 * (1 - t) * t * y1 + t * t * y2 + Math.random() * this.shake - this.shake / 2,
      );
    }
    this.setXY(
      x2 + Math.random() * this.shake - this.shake / 2,
      y2 + Math.random() * this.shake - this.shake / 2,
    );
    this.context.lineTo(this.x, this.y);
  }

  distance(x0, y0, x1, y1) {
    const dx = x1 - x0;
    const dy = y1 - y0;
    return Math.sqrt(dx * dx + dy * dy);
  }

  setXY(x, y) {
    this.prevX = this.x;
    this.prevY = this.y;
    this.x = x;
    this.y = y;
  }
}

export default Shaky;
